<template>
  <div
    class="Burger"
  >
    <input
      type="checkbox"
      id="menuToggler"
      class="input-toggler"
      autofocus="true"
      @change="toggleSidebar($event)"
    />
    <label for="menuToggler" id="menuTogglerLabel" class="menu-toggler" role="button" aria-pressed="false" aria-expanded="false" aria-label="Navigation button">
      <span class="menu-toggler__line"></span>
      <span class="menu-toggler__line"></span>
      <span class="menu-toggler__line"></span>
    </label>
  </div>
</template>

<script>
export default {
  data: () => ({

  }),

  methods: {
    toggleSidebar() {
      this.$store.dispatch('toggleSidebar')
    }
  },
}
</script>

<style lang="scss">
.Burger {
  // same as var(--toggler-line-number)
  $total: 3;

  .menu-toggler {
    border-radius: calc(var(--toggler-line-size) / 2);
    display: block;
    width: var(--toggler-size);
    height: var(--toggler-size);
    position: fixed;
    top: var(--toggler-offset-top);
    left: var(--toggler-offset-left);
    cursor: pointer;
    z-index: 777;
  }

  .menu-toggler__line {
    height: var(--toggler-line-size);
    background: var(--toggler-color);
    position: absolute;
    border-radius: calc(var(--toggler-line-size) / 2);
    left: 0;
    right: 0;
    transition: all .25s ease-out;

    $num: 1;

    @while $num <= $total {
      &:nth-child(#{$num}) {
        top: calc(var(--toggler-line-size) * #{$num} + (var(--toggler-line-size) * (#{$num} - 2)));
      }

      $num: $num + 1;
    }
  }

  .input-toggler {
    position: absolute;
    left: -100%;

    &:focus ~ .menu-toggler {
      outline: 1px dotted;
    }

    &:checked ~ .menu-toggler {
      .menu-toggler__line:not(:first-child):not(:last-child) {
        opacity: 0;
      }

      .menu-toggler__line:first-child,
      .menu-toggler__line:last-child {
        background-color: var(--toggler-color-hover);
      }

      .menu-toggler__line:first-child {
        transform: translateY(calc(var(--toggler-line-size) * (var(--toggler-line-number) - 1))) rotate(45deg);
      }

      .menu-toggler__line:last-child {
        transform: translateY(calc(-1 * var(--toggler-line-size) * (var(--toggler-line-number) - 1))) rotate(-45deg);
      }
    }

    &:checked ~ .sidebar {
      transform: translateX(0);
      opacity: .98;
    }
  }
}

// variables
:root {
  --toggler-size: 30px;
  --toggler-line-number: 3;
  --toggler-line-size: calc(var(--toggler-size) / (var(--toggler-line-number) + var(--toggler-line-number) - 1));
  --toggler-offset-left: 10px;
  --toggler-offset-top: 10px;
  --toggler-color: #4AC828;
  --toggler-color-hover: #4AC828;
}
</style>
